const maskImage = {
    name: "mask-image",
    path: "mask-image",
    title: "mask-image",
    description: "Utilities for controlling an element's mask image.",
    value: {
        'mask-image':{
          'mask-image-[<value>]': '<value>',
          'mask-image-none': 'none',
        },
    },
    exampleData: [
        {
            "title": "mask-image-[<value>]",
            "description": " syntax to set the mask image of an element:",
            "moreDescription": "",
            "parentClass": "h-48 max-w-96 mx-auto",
            "example": {
                "element": "img",
                "src": [
                    {
                        "divClass":"h-48 w-full  mask-size-[100%_130%] mask-no-repeat mask-center  rounded-lg bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[url(./img/brush_stroke.webp)] bg-cover bg-center mask-add"
                    },
                    
                ],
                "className": "relative",
                "code": `<div class="mask-image-[url(/img/scribble.png)] bg-image-[url(/img/mountains.jpg)] ...">
  <!-- ... -->
</div>`
            }
        },
        {
            "title": "mask-image-[<value>]",
            "description": " syntax to set the mask image of an element:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-3 gap-6 gap-y-16 !bg-none !border-0 py-5",
            "example": {
                "element": "img",
                "src": [
                    {
                        "divClass":"aspect-square border w-full mask-center  rounded-lg bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[linear-gradient(black,_transparent)] bg-cover bg-center"
                    },
                    {
                        "divClass":"aspect-square border w-full mask-center  rounded-lg bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[linear-gradient(to_right,black,_transparent)] bg-cover bg-center"
                    },
                    {
                        "divClass":"aspect-square border w-full mask-center  rounded-lg bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[linear-gradient(360deg,black,_transparent)] bg-cover bg-center"
                    },
                    {
                        "divClass":"aspect-square border w-full mask-center  rounded-lg bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[linear-gradient(to_left,black,_transparent)] bg-cover bg-center"
                    },
                    {
                        "divClass":"aspect-square border w-full mask-center  rounded-lg bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[linear-gradient(to_top_right,black,_transparent)] bg-cover bg-center"
                    },
                    {
                        "divClass":"aspect-square border w-full mask-center  rounded-lg bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[linear-gradient(to_top_left,black,_transparent)] bg-cover bg-center"
                    },

                    {
                        "divClass":"aspect-square border mask-no-repeat w-full mask-center mask-left  rounded-lg bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[radial-gradient(circle_at_left,_black_50%,_rgba(0,_0,_0,_0.1)_50%)] bg-cover bg-center"
                    },
                    {
                        "divClass":"aspect-square border mask-no-repeat w-full mask-center mask-center  rounded-lg bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[radial-gradient(circle,_black_50%,_rgba(0,_0,_0,_0.1)_50%)] bg-cover bg-center"
                    },
                    {
                        "divClass":"aspect-square border mask-no-repeat w-full mask-center mask-right  rounded-lg bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[radial-gradient(circle_at_100%_50%,_black_50%,_rgba(0,_0,_0,_0.1)_50%)] bg-cover bg-center"
                    },
                    
                ],
                "className": "relative",
                "code": `<div class="mask-image-[linear-gradient(black,_transparent)] bg-image-[url(/img/mountains.jpg)] ..."></div>
<div class="mask-image-[linear-gradient(to_right,black,_transparent)] bg-image-[url(/img/mountains.jpg)] ..."></div>
<div class="mask-image-[linear-gradient(360deg,black,_transparent)] bg-image-[url(/img/mountains.jpg)] ..."></div>
<div class="mask-image-[linear-gradient(to_left,black,_transparent)] bg-image-[url(/img/mountains.jpg)] ..."></div>
<div class="mask-image-[linear-gradient(to_top_right,_black,_transparent)] bg-image-[url(/img/mountains.jpg)] ..."></div>
<div class="mask-image-[linear-gradient(to_top_left,_black,_transparent)] bg-image-[url(/img/mountains.jpg)] ..."></div>
<div class="mask-image-[radial-gradient(circle_at_left,_black_50%,_rgba(0,_0,_0,_0.1)_50%)] bg-image-[url(/img/mountains.jpg)] ..."></div>
<div class="mask-image-[radial-gradient(circle,_black_50%,_rgba(0,_0,_0,_0.1)_50%)] bg-image-[url(/img/mountains.jpg)] ..."></div>
<div class="mask-image-[radial-gradient(circle_at_100%_50%,_black_50%,_rgba(0,_0,_0,_0.1)_50%)] bg-image-[url(/img/mountains.jpg)] ..."></div>`
            }
        }
    ]
};

export default maskImage;